export enum ProductOrderStatus {
  NEW = 'NEW',

  ACTIVE = 'ACTIVE',

  INACTIVE = 'INACTIVE',
}
